import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";
import { NewGoodsProposalModel } from "../vo/new-goods-proposal.model";
import { KYMW6901Component } from "../../kymw6901.component";

interface NewGoodsProposalItem {
  ProposalId: string;
  ProposalStatus: string;
  ClassCode: string;
  ProposalBuyerId: string;
  ProposalGoodsName: string;
  ProposalName: string;
  JanCode: string;
  ProposalSalesPoint: string;
  SuggestedPriceSellingNormal: string;
  SuggestedPriceSellingSpecial1: string;
  SuggestedPriceSellingSpecial2: string;
  SuggestedPricePurchaseNormal: string;
  SuggestedPricePurchaseSpecial1: string;
  SuggestedPricePurchaseSpecial2: string;
  ConsumeByDate: string;
  ConsumeTerm: string;
  ExpansionStartSuggestedOrderCode: string;
  ExpansionStartSuggestedCatalog: string;
  SuggestedExpansionDiv: string;
  SuggestedExpansionDivOther: string;
  CoopCode: string[];
  MonthAge: string;
  ProductionFactory: string;
  ManufacturingFactory: string;
  DeliGoodsStandardCheckedFlg: string;
  GoodsStandardCheckedOrderFlg: string;
  TemperatureDiv: string;
  OrderClientName: string;
  MakerName: string;
  Allergen: string;
  AdditionObject: string;
  CookingMethod: string;
  MdbRegistFlg: string;
  ShootingOrder: string;
  ImagePhoto: string;
  ShootingImage: string;
  Note: string;
  RejectionReason: string;
  PredictedPoints: string;
}
type GetNewGoodsProposalItemResponse = NewGoodsProposalItem;

/**
 * 新規商品提案情報を取得するサービス
 *
 * @export GetNewGoodsProposalItemService
 * @class GetNewGoodsProposalItemService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetNewGoodsProposalItemService extends PlessJsonResponderSub<GetNewGoodsProposalItemResponse> {
  private proposalId = '';
  private model: KYMW6901ProposalTabModel
  private successFunc: (newGoodsProposal: NewGoodsProposalModel) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetNewGoodsProposalItemService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProposalId: this.proposalId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetNewGoodsProposalItemService
   */
  execute(
    proposalId: string,
    model: KYMW6901ProposalTabModel,
    successFunc: (newGoodsProposal: NewGoodsProposalModel) => void
  ) {
    this.proposalId = proposalId;
    this.model = model;
    this.successFunc = successFunc;
    this.send('getNewGoodsProposalItem', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetNewGoodsProposalItemService
   */
  success(data: GetNewGoodsProposalItemResponse) {
    const item = data;
    const result = new NewGoodsProposalModel(
      item.ProposalId,
      item.ProposalStatus,
      item.ClassCode,
      item.ProposalBuyerId,
      item.ProposalGoodsName,
      item.ProposalName,
      item.JanCode,
      item.ProposalSalesPoint,
      item.SuggestedPriceSellingNormal,
      item.SuggestedPriceSellingSpecial1,
      item.SuggestedPriceSellingSpecial2,
      item.SuggestedPricePurchaseNormal,
      item.SuggestedPricePurchaseSpecial1,
      item.SuggestedPricePurchaseSpecial2,
      KYMW6901ProposalTabModel.calcGpr(item.SuggestedPriceSellingNormal, item.SuggestedPricePurchaseNormal),
      KYMW6901ProposalTabModel.calcGpr(item.SuggestedPriceSellingSpecial1, item.SuggestedPricePurchaseSpecial1),
      KYMW6901ProposalTabModel.calcGpr(item.SuggestedPriceSellingSpecial2, item.SuggestedPricePurchaseSpecial2),
      item.ConsumeByDate,
      item.ConsumeTerm,
      item.ExpansionStartSuggestedOrderCode,
      item.ExpansionStartSuggestedCatalog,
      item.SuggestedExpansionDiv,
      item.SuggestedExpansionDivOther,
      this.model.toCoopMap(item.CoopCode),
      item.MonthAge,
      item.ProductionFactory,
      item.ManufacturingFactory,
      item.DeliGoodsStandardCheckedFlg === "1",
      item.GoodsStandardCheckedOrderFlg  === "1",
      item.TemperatureDiv,
      item.OrderClientName,
      item.MakerName,
      item.Allergen,
      item.AdditionObject,
      item.CookingMethod,
      item.MdbRegistFlg === "1",
      item.ShootingOrder,
      item.ImagePhoto,
      item.ShootingImage,
      item.Note,
      item.RejectionReason,
      item.PredictedPoints,
    );
    if (this.successFunc) {
      this.successFunc(result);
    }
  }
}
